import { createFileRoute } from "@tanstack/react-router";
import { AuditLogListPage } from "@client/components/admin/audit-logs/audit-log-list-page";

/**
 * 团队设置-审计日志：统一审计视图（通用审计 + 原数据中心权限审计同集合），
 * 表格与筛选实现在 AuditLogListPage，标题/筛选注入 SecondaryNav 顶栏。
 */
export const Route = createFileRoute("/_app/tenant-settings/audit-logs/")({
  component: AdminAuditLogs,
});

function AdminAuditLogs() {
  return <AuditLogListPage />;
}
